// 潘通色号下拉列表
import request from '@/utils/request'

// PC-预约单列表
export function apiGetAppMaterialList (data) {
  return request({
    url: '/plan/appointment/appts/getApptsList',
    method: 'post',
    data: data
  })
}

// PC-预约详情
export function apiGetApptsDetail (data) {
  return request({
    url: '/plan/appointment/appts/getApptsDetail',
    method: 'post',
    data: data
  })
}

// PC-驳回预约
export function apiGetAppRejectAppts (data) {
  return request({
    url: '/plan/appointment/appts/rejectAppts',
    method: 'post',
    data: data
  })
}

// PC-取消预约
export function apiGetAppCancelAppts (data) {
  return request({
    url: '/plan/appointment/appts/cancelAppts',
    method: 'post',
    data: data
  })
}

// PC-司机用户下拉列表
export function apiGetDriverUserInfoList (data) {
  return request({
    url: '/plan/appointment/appts/getDriverUserInfoList',
    method: 'post',
    data: data
  })
}

// PC-预约单编辑
export function apiModifyAppts (data) {
  return request({
    url: '/plan/appointment/appts/modifyAppts',
    method: 'post',
    data: data
  })
}

// PC-预约生效
export function apiGetAppEnableAppts (data) {
  return request({
    url: '/plan/appointment/appts/enableAppts',
    method: 'post',
    data: data
  })
}

// PC-角色用户导出
export function apiRoleExportRoleUserList (data) {
  return request({
    url: '/plan/appointment/roleUser/exportRoleUserList',
    method: 'post',
    data: data
  })
}

// PC-预约审核
export function apiGetAppAuditAppts (data) {
  return request({
    url: '/plan/appointment/appts/auditAppts',
    method: 'post',
    data: data
  })
}

// PC-预约撤销
export function apiGetAppRetractAppts (data) {
  return request({
    url: '/plan/appointment/appts/retractAppts',
    method: 'post',
    data: data
  })
}

// 导出列表
export function apiExportApptsList (data) {
  return request({
    url: '/plan/appointment/appts/exportApptsList',
    method: 'post',
    data: data
  })
}

// PC-角色用户列表
export function apiGetRoleUserList (data) {
  return request({
    url: '/plan/appointment/roleUser/list',
    method: 'post',
    data: data
  })
}

// PC-角色用户新增或编辑
export function apiRoleSaveOrUpdate (data) {
  return request({
    url: '/plan/appointment/roleUser/saveOrUpdate',
    method: 'post',
    data: data
  })
}

// PC-电梯空闲时间列表
export function apiGetApptsLiftFreeTimes (data) {
  return request({
    url: '/plan/appointment/appts/getApptsLiftFreeTimes',
    method: 'post',
    data: data
  })
}

// PC-车牌黑名单查询列表
export function apiGetBlackLicenseList (data) {
  return request({
    url: '/plan/appointment/appts/license/getBlackLicenseList',
    method: 'post',
    data: data
  })
}

// PC-车牌黑名单新增或编辑
export function apiSaveOrUpdateBlackLicense(data) {
  return request({
    url: '/plan/appointment/appts/license/saveOrUpdateBlackLicense',
    method: 'post',
    data: data
  })
}

// PC-车牌黑名单批量删除
export function apiBatchDeleteBlackLicense(data) {
  return request({
    url: '/plan/appointment/appts/license/deleteBlackLicense',
    method: 'post',
    data: data
  })
}

// PC-车牌黑名单启用或禁用
export function apiEnableBlacklicense(data) {
  return request({
    url: '/plan/appointment/appts/license/enableBlacklicense',
    method: 'post',
    data: data
  })
}
